import React from "react";
import Link from "next/link";
import Button from "components/button";
import getServerSidePropsWithNonAuth from "middleware/non-auth";
import { wrapper } from "store";
import { GetServerSideProps } from "next";
import { updateDefault } from "features/seo/seoSlice";

export const getServerSideProps: GetServerSideProps = wrapper.getServerSideProps(
  (store) =>
    getServerSidePropsWithNonAuth(async () => {
      store.dispatch(updateDefault({}));
      return { props: {} };
    })
);

const Authen: React.FC<Record<string, never>> = () => {
  return (
    <>
      <div className="w-full h-mobile-contain">
        <div className="flex flex-col items-center justify-center p-5 h-full">
          <div className="mb-5">
            <img src="/assets/sidemenu-logo/person-large.svg" />
          </div>
          <div className="text-center px-4 text-sm text-grey-80 mb-8">
            Đăng nhập để trò chuyện, tương tác với <br /> người ảnh hưởng cùng
            nhiều tính năng khác.
          </div>
          <div className="w-full mb-3">
            <Link href="/m/login">
              <Button>Đăng nhập</Button>
            </Link>
          </div>
          <div className="w-full text-center text-medium-blue text-sm underline cursor-pointer">
            <Link href="/m/register">Đăng ký</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Authen;
